import {
  DnDArea,
  File,
  UploadLabel,
} from "components/design/UploadFileSection";
import { Banner } from "components/DesignSystem/Banner/Banner";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { DownloadIcon } from "components/icons/Download";
import {
  BULK_ADD_BILLS_TEMPLATE_URL,
  COA_IMPORT_SAMPLE_CSV_URL,
} from "types/contants/sampleExcelSheet";
import { ImportCOAHeader } from "./ImportCOA";

type ImportCOAFileUploadProps = {
  file: File | null;
  onFileUpload: (file: File | null) => void;
  onNext: () => void;
};

export const ImportCOAFileUpload = ({
  file,
  onFileUpload,
  onNext,
}: ImportCOAFileUploadProps) => {
  return (
    <Modal.Content size="xl" useCustomOverlay>
      <ImportCOAHeader />
      <Modal.Body className="sm:t-px-4">
        <UploadLabel className="t-mb-2">
          Download the pre-formatted template to ensure your data is properly
          structured. Add the Chart of Accounts details to the template and
          upload it. If importing from Quickbooks, you can find the Chart of
          Accounts list here: Reports {`->`} Account List {`->`} Export as CSV
        </UploadLabel>
        <div className="t-flex t-flex-col t-gap-5">
          <span>
            <Button
              size="small"
              onClick={() => window.open(COA_IMPORT_SAMPLE_CSV_URL)}
            >
              <DownloadIcon />
              <span className="t-ml-1.5">Download Template</span>
            </Button>
          </span>
          {file ? (
            <File
              file={file}
              onCancel={() => onFileUpload(null)}
              onDelete={() => onFileUpload(null)}
              isUploading={true}
              isUploaded={Boolean(file)}
            />
          ) : (
            <DnDArea
              onDrop={(acceptedFiles) => onFileUpload(acceptedFiles[0])}
              accept={{
                "text/csv": [".csv"],
              }}
              subText="File Format: csv"
              multiple={false}
            />
          )}
        </div>
        <div className="t-mt-5">
          <Banner
            type="neutral"
            description="This will replace the existing chart of accounts and uncategorise transactions."
          />
        </div>
      </Modal.Body>
      {file && (
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button customType="primary" onClick={onNext}>
            Next
          </Button>
        </Modal.FooterButtonGroup>
      )}
    </Modal.Content>
  );
};
